import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TextInputComponent } from '../../../../../ui/form-components/text-input/text-input.component';

@Component({
  selector: 'app-member-table-text-input',
  templateUrl: '../../../../../ui/form-components/text-input/text-input.component.html',
  styleUrls: ['../member-table-input.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MemberTableTextInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class MemberTableTextInputComponent extends TextInputComponent {}
